import * as React from "react";
import { forwardRef, useEffect, useState } from "react";
import ClickToEdit from "react-click-to-edit";

const roleMapping = {
  delegate: "DELEGATE",
  exhibitor: "EXHIBITOR",
  speaker: "SPEAKER",
  superadmin: "ORGANISER",
  "vip/faculty": "VIP / FACULTY",
};

export const PrintContent = React.forwardRef<HTMLDivElement, any>(
  (props, ref) => {
    const { user, setEditMode } = props;
    const { fullName, role, qrLabel } = user;

    const renderField = (value, className = "") => (
      <ClickToEdit
        wrapperClass={`line ${className}`}
        initialValue={value}
        startEditing={() => {
          setEditMode(true);
        }}
        endEditing={() => {
          setEditMode(false);
        }}
      />
    );

    return (
      <div ref={ref}>
        <style type="text/css" media="print">
          {`
            @page { size: 4in 6in;
              margin: 3in 1cm 1cm 1cm;
            }
            .line {
              font-family: Georgia, 'Times New Roman', serif;
              font-size: 12pt;
              display: block !important;
              margin-bottom: 5pt;
              text-align: center;
              line-height: 1.3;
            }
            .fullName {
              font-size: 14pt;
              font-weight: bold;
              text-align: center;
              color: #000;
            }
            .role {
              font-style: italic;
              font-size: 12pt;
              margin-bottom: 1pt;
              text-align: center;
              color: #000;
            }
            .CTE--wrapper:after {
              content: '' !important;
            }
            #qrLabel {
              display: block;
              margin: auto;
            }
          `}
        </style>
        {/* <div className="imageGap"></div> */}
        {renderField(fullName, "fullName text-uppercase")}
        {renderField(roleMapping[role], "role text-uppercase")}
        {/* <div className="fullName">{fullName}</div>
        <div className="role">{roleMapping[role]}</div> */}

        <img id="qrLabel" src={qrLabel} />
      </div>
    );
  }
);

// const PrintContent = forwardRef(PrintContentRef)
export default PrintContent;
